import { Fragment, useEffect, useState } from "react"
import styled from "styled-components"
import { TypographyCenter } from "theme/shared"
import BlueCircleIcon from "../../../../reusable/icons/BlueCircleIcon"
import EmptyCircleIcon from "../../../../reusable/icons/EmptyCircleIcon"
import RedXIcon from "../../../../reusable/icons/RedXIcon"

const StyledCellDiv = styled.div<{ $width?: string }>`
  ${(p) => (p.$width ? `width: ${p.$width};` : `width: 50%;`)}
  margin-top: 30px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;

  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
    justify-content: center;
  }
`

const StyledCellDivWrapper = styled.div`
  width: 95%;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
  }
`

const StyledSpan = styled.span`
  margin-left: 16px;
  color: ${(p) => p.theme.colors.nonExistentBlue};
  margin-right: 10px;
`

const StyledSpanText = styled.span`
  display: inline-block;
`

const StyledList = styled.ol`
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0px;
  border: 1px solid rgb(153, 153, 153);
  border-top: unset;
  margin-top: 0px;
  border-left: unset;
  text-align: right;
`

const StyledListItem = styled.li`
  width: 50%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 11px;
  padding: 5px;
  border-left: 1px solid rgb(153, 153, 153);
`

const StyledHeaderWrapper = styled.div`
  background: rgb(213, 213, 213);
  padding: 10px;
  border: 1px solid rgb(153, 153, 153);
  width: 100%;
`

const SafetyIcons = [
  { key: 0, icon: <BlueCircleIcon /> },
  { key: 1, icon: <EmptyCircleIcon /> },
  { key: 2, icon: <RedXIcon /> },
]

type SafetyOptionsTableProps = {
  names: string[]
  items: any
  width?: string
}

const SafetyOptionsTable = ({
  names,
  items,
  width,
}: SafetyOptionsTableProps) => {
  const [name, setName] = useState("")
  useEffect(() => {
    converNames()
  }, [])

  const converNames = () => {
    const uniqueNames = names.filter(
      (value, index, array) => array.indexOf(value) === index
    )

    if (uniqueNames.length === 1) setName(uniqueNames[0])
    else {
      setName(
        uniqueNames.slice(0, -1).join(", ") + " ו- " + uniqueNames.slice(-1)
      )
    }
  }
  const secondColumnStart = Math.ceil(items.length / 2)

  return (
    <StyledCellDiv $width={width}>
      <StyledCellDivWrapper>
        <StyledHeaderWrapper>
          <TypographyCenter $fontSize="11px" $fontWeight="400">
            פירוט מערכות הבטיחות המותנקות ברכב ברמות גימור{" "}
            <StyledSpanText>{name}</StyledSpanText>
          </TypographyCenter>
        </StyledHeaderWrapper>
        <StyledList>
          {items.slice(0, secondColumnStart).map((item, i) => (
            <Fragment key={`SafetyOptionsTable-${i}`}>
              {items[i + secondColumnStart] && (
                <StyledListItem>
                  <StyledSpan>
                    {SafetyIcons[items[i + secondColumnStart].optionType - 1]
                      ? SafetyIcons[items[i + secondColumnStart].optionType - 1]
                          .icon
                      : items[i + secondColumnStart].optionValue}
                  </StyledSpan>
                  {items[i + secondColumnStart].optionName}
                </StyledListItem>
              )}

              <StyledListItem>
                <StyledSpan>
                  {SafetyIcons[item.optionType - 1]
                    ? SafetyIcons[item.optionType - 1].icon
                    : item.optionValue}
                </StyledSpan>
                {items[i].optionName}
              </StyledListItem>

              {i === secondColumnStart - 1 && items.length % 2 !== 0 && (
                <StyledListItem></StyledListItem>
              )}
            </Fragment>
          ))}
        </StyledList>
      </StyledCellDivWrapper>
    </StyledCellDiv>
  )
}

export default SafetyOptionsTable
